import React from "react";
import { Switch, FormControlLabel, Button, Grid } from "@mui/material";
import { useFormContext, Controller } from "react-hook-form";
import AuraBaseDialog from "app/main/apps/common/AuraBaseDialog";

const SupplierOrderConfirmationDialog = (props) => {
  const { open, onClose, onSubmit, title } = props;
  const methods = useFormContext();
  const { control } = methods;

  const additionalButtons = (
    <div className="flex justify-end">
      <Button onClick={onClose}>Cancel</Button>
      <Button variant="contained" color="secondary" onClick={onSubmit}>
        Proceed
      </Button>
    </div>
  );

  return (
    <>
      <AuraBaseDialog
        dialogProps={{ open }}
        dialogParam={{
          title: props.title || "Confirmation",
          hideDialogActions: true,
          style: {
            dialogActionsClass: "ml-auto",
          },
        }}
        closeDialog={onClose}
        disableSubmitButton={() => {}}
        additionalButton={additionalButtons}
      >
        <Grid container direction="column">
          {/* Row 1 */}
          <Grid container item alignItems="center" className="!p-0">
            <Grid item xs={12} sm={12} className="p-0">
              <Controller
                name="is_drawing_required"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    label="Is drawing required for this order?"
                    labelPlacement="start"
                    control={
                      <Switch
                        checked={field.value}
                        onChange={(e) => field.onChange(e.target.checked)}
                        color="secondary"
                      />
                    }
                    sx={{
                      justifyContent: "space-between",
                      width: "100%",
                      marginLeft: 0,
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>

          {/* Row 2 */}
          <Grid container item alignItems="center" className="!p-0">
            <Grid item xs={12} sm={12}>
              <Controller
                name="is_required_product_images"
                control={control}
                render={({ field }) => (
                  <FormControlLabel
                    label="Is product images required before shipment for this order?"
                    labelPlacement="start"
                    control={
                      <Switch
                        checked={field.value}
                        onChange={(e) => field.onChange(e.target.checked)}
                        color="secondary"
                      />
                    }
                    sx={{
                      justifyContent: "space-between",
                      width: "100%",
                      marginLeft: 0,
                    }}
                  />
                )}
              />
            </Grid>
          </Grid>
        </Grid>
      </AuraBaseDialog>
    </>
  );
};

export default SupplierOrderConfirmationDialog;
